import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCustomerPortal = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M19.335 22.667v-.834A3.333 3.333 0 0 0 16 18.5h-5a3.333 3.333 0 0 0-3.333 3.333v.834",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("circle", {
			cx: 13.501,
			cy: 11.833,
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round",
			r: 3.333
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M24.333 22.667v-.834A3.333 3.333 0 0 0 21 18.5v0M18.5 8.5a3.333 3.333 0 0 1 0 6.667",
			stroke: "#748094",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgCustomerPortal;
